export const COMPLEX_ISLAND_VERTICAL_MARGIN = 24;
